// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsHeader-cls1_cZl","cls2":"NewsHeader-cls2_Rpx NewsHeader-cls1_cZl"};